import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { siteConfig } from "../Datas/productData";
import "../css/paysuccess.css";

const PaySuccess = () => {
  useEffect(() => {
    document.title = `Order confirmed — ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="payment-success" id="main-content">
      <section className="payment-success__card" aria-labelledby="success-title">
        <div className="payment-success__icon" aria-hidden="true">
          <FontAwesomeIcon icon={faCheck} />
        </div>
        <p className="payment-success__eyebrow">Order confirmed</p>
        <h1 id="success-title">Thank you—your happy mail is in motion.</h1>
        <p className="payment-success__message">
          Your order has been received by {siteConfig.brandName}. A confirmation
          email with your order details is on its way.
        </p>

        <div className="payment-success__timeline" aria-label="What happens next">
          <div><span>1</span><p><strong>Confirmed</strong>Your order is safely in our system.</p></div>
          <div><span>2</span><p><strong>Prepared</strong>We will pack every paper detail with care.</p></div>
          <div><span>3</span><p><strong>Dispatched</strong>Tracking will arrive by email when available.</p></div>
        </div>

        <div className="payment-success__actions">
          <Link className="payment-success__primary" to="/shop">Keep shopping</Link>
          <Link className="payment-success__secondary" to="/">Back to home</Link>
        </div>
        <p className="payment-success__help">
          Need to change something? <Link to="/contact">Contact us as soon as possible.</Link>
        </p>
      </section>
    </main>
  );
};

export default PaySuccess;
